module.exports = __webpack_public_path__ + "img/1F636.f47aeb5a.svg";